module.exports = __webpack_public_path__ + "img/confirmation.460d43eb.gif";